import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { toCroppedImage } from '~/shared/utils/image'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ArticleMainItem extends BaseModel {
  static override constructorName = 'ArticleMainItem'

  id: number = 0
  name: string = ''
  slug: string = ''
  image: string = ''
  'preview_image': string = ''
  preview: string = ''
  'published_at': string = ''
  'created_at': string = ''
  'date_publication': string = ''
  'is_published': boolean = false
  'likes_count': number = 0
  'views_count': number = 0
  'preview_description': string = ''

  constructor(data?: unknown) {
    super(data)
    if (!isUnknownObject(data)) return

    fillOwnProperties(this, data)

    this.image = toCroppedImage(this.preview_image || this.preview || this.image)
  }

  get link(): string {
    return this.preview ? `/digital-lecture/${this.slug}` : `/news/${this.slug}`
  }

  get publicationDate(): string {
    return this.published_at || this.date_publication || this.created_at
  }
}

registerModel(ArticleMainItem)
